import shallow from 'zustand/shallow';
import { useAuth } from '../state';
import { useEffect, useState } from 'react';

export enum UserType {
  Completed = 'Completed',
  NonVerified = 'NonVerified',
  Verified = 'Verified',
  NonCompleted = 'NonCompleted',
  Guest = 'Guest', // it't not used, added only to handle intermediate state
}

export const useUserTypes = () => {
  const user = useAuth(s => s.user, shallow);

  const getUserType = (): UserType => {
    if (!user?.token) return UserType.Guest;
    if (user.firstName && user.lastName && user.email) {
      if (user.gender && user.dateOfBirth) {
        if (user.isVerified === true) {
          return UserType.Completed;
        } else {
          return UserType.NonVerified;
        }
      } else {
        if (user.isVerified === true) {
          return UserType.Verified;
        } else {
          return UserType.NonVerified;
        }
      }
    } else {
      return UserType.NonCompleted;
    }
  };

  const [userType, setUserType] = useState<UserType | null>(getUserType());

  useEffect(() => {
    setUserType(getUserType());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return {
    userType,
  };
};
